import { View, Text } from "@src/components";

/** Full-page notice shown when a non-support user opens a support-only tool. */
export function SupportAccessRestricted() {
  return (
    <View flex={1} justifyContent="center" alignItems="center">
      <Text textStyle="md/regular" color="textMuted">
        Access restricted to support users.
      </Text>
    </View>
  );
}
